/**
 * UI registry: explore slugs, labels, gradients, subtype options (for badges / filters).
 */

import { CONTENT_TYPE, EXPLORE_SLUG_TO_TYPE, TYPE_TO_EXPLORE_SLUG, UNIFIED_CATALOG_SLUG } from "./contentConstants";

export const CONTENT_TYPES = {
  [UNIFIED_CATALOG_SLUG]: {
    name: "Read",
    singular: "Work",
    path: UNIFIED_CATALOG_SLUG,
    route: `/${UNIFIED_CATALOG_SLUG}`,
    typeValue: CONTENT_TYPE.STORY,
    defaultGradient: "linear-gradient(135deg, #8E3A6D 0%, #D97A9E 100%)",
    defaultBadge: "primary",
    typeOptions: [],
    colors: {},
    icon: "FaBookOpen",
  },
  articles: {
    name: "Articles",
    singular: "Article",
    path: "articles",
    route: "/articles",
    typeValue: CONTENT_TYPE.ARTICLE,
    defaultGradient: "linear-gradient(135deg, #8E3A6D 0%, #D97A9E 100%)",
    defaultBadge: "success",
    typeOptions: ["Essay", "Opinion", "Guide", "News", "Other"],
    colors: {
      Essay: { badge: "primary", gradient: "linear-gradient(135deg, #8E3A6D 0%, #D97A9E 100%)" },
      Opinion: { badge: "warning", gradient: "linear-gradient(135deg, #8A5A32 0%, #D97A9E 100%)" },
      Guide: { badge: "info", gradient: "linear-gradient(135deg, #D97A9E 0%, #8E3A6D 100%)" },
      News: { badge: "danger", gradient: "linear-gradient(135deg, #8F3038 0%, #8A5A32 100%)" },
      Other: { badge: "secondary", gradient: "linear-gradient(135deg, #8E3A6D 0%, #D97A9E 100%)" },
    },
    icon: "FaRegFileAlt",
  },
};

export const getContentTypeConfig = (exploreSlugOrType) => {
  if (!exploreSlugOrType) return CONTENT_TYPES[UNIFIED_CATALOG_SLUG];
  const key = String(exploreSlugOrType).toLowerCase();
  if (CONTENT_TYPES[key]) return CONTENT_TYPES[key];
  const slug = TYPE_TO_EXPLORE_SLUG[key];
  if (slug && CONTENT_TYPES[slug]) return CONTENT_TYPES[slug];
  return CONTENT_TYPES[UNIFIED_CATALOG_SLUG];
};

export const getExploreSlugForItem = (_item) => UNIFIED_CATALOG_SLUG;

export const getTypeBadgeColor = (exploreSlug, subtype) => {
  const config = getContentTypeConfig(exploreSlug);
  return config.colors?.[subtype]?.badge || config.defaultBadge;
};

export const getTypeGradient = (exploreSlug, subtype) => {
  const config = getContentTypeConfig(exploreSlug);
  return config.colors?.[subtype]?.gradient || config.defaultGradient;
};

export const getAllContentTypes = () => Object.keys(CONTENT_TYPES);

export { EXPLORE_SLUG_TO_TYPE, CONTENT_TYPE };
